import React from 'react';
import { brandLogoInfo } from '../config/aiVisibilityLogos';

/**
 * AI Visibility marka logosu, OPTİK boyut eşitlemeli (16 Eki 2026).
 * Aynı yükseklikte uzun kelime markası dev, kare amblem cılız görünür; bu yüzden
 * alan eşitlenir: oran (w/h) 3 olan logo `size` yüksekliğinde, daha uzun olan
 * kısalır, daha kare olan büyür (0,55×–1,5× arası), genişlik `maxW` ile sınırlı.
 * Logo yoksa `fallback` (varsayılan: marka adı) basılır.
 */
export default function AiBrandLogo({ name, size = 18, maxW = 120, className = '', fallback }) {
  const info = brandLogoInfo(name);
  if (!info) return fallback === undefined ? <span className={className}>{name}</span> : fallback;
  const r = info.r || 3;
  let h = size * Math.min(1.5, Math.max(0.55, Math.sqrt(3 / r)));
  let w = h * r;
  if (w > maxW) { w = maxW; h = w / r; }
  return (
    <img src={info.src} alt={name} title={name} loading="lazy" draggable={false}
      className={`inline-block select-none object-contain ${className}`}
      style={{ height: Math.round(h * 10) / 10, width: Math.round(w * 10) / 10 }} />
  );
}

export const hasBrandLogo = (name) => !!brandLogoInfo(name);
